import React, { useContext } from 'react';
import S from "./ModernPortfolioTheory";
import CardHeader from "../CardHeader";
import FundContext from '@/components/FundSingle/FundProvider';
import Table from "../../../Table/index"; 
import moment from 'moment';

const ModernPortfolioTheory: React.FC<FundSingle> = () => {
    const { fundRiskDetails } = useContext(FundContext);
    
    if (!fundRiskDetails) return null;

    var riskStatistics = fundRiskDetails.RiskStatistics.find((item: any) => item.ReturnType == 'Nav');
    var riskStatsDate = riskStatistics.Date;

    const GetRiskValue = (data: any) => {
        
        if (!data) return ['-', '-', '-'];

        const threeYear = data.find((item: any) => item.TimePeriod === 'M36');

        // Only return 3 year
        var threeYearValue = threeYear.Value;

        // Only 2 decimals
        return threeYearValue.toFixed(2);
    }
    
    var tableData = {
        headings: ['', 'STANDARDINDEX'],
        rows: {
            '3 år Förklaringsvärde': [GetRiskValue(riskStatistics.RSquareds)],
            '3 år Alfa': [GetRiskValue(riskStatistics.Alphas)],
            '3 år Beta': [GetRiskValue(riskStatistics.Betas)],
        }
    }

    return (
        <S.AllocationWrapper>
            <CardHeader title="Modern portföljteori" subTitle={moment(riskStatsDate).format('YYYY-MM-DD')} />
            <Table tableData={tableData} reverse={true} />
        </S.AllocationWrapper>
    );
};

export default ModernPortfolioTheory;
